import { Modal } from "antd"
import { QuotationItemForm } from "./QuotationItemForm"
import { QuotationDetail } from "src/common/models/quotation"
import { SystemDescriptions } from "src/common/descriptions"

interface Props {
    open: boolean
    onCancel?: () => void
    onAccept: (detailItem: QuotationDetail) => void
    okText: string
    cancelText: string
    initialValues?: QuotationDetail
}

export const QuotationItemModal = (props: Props) => {

    const descriptions = SystemDescriptions.PAGES.QUOTATION.CREATE

    const onFinish = (detailItem: QuotationDetail) => {
        props.onAccept(detailItem)
    }

    return (
        <Modal
            title={descriptions.DETAIL.FORM.TITLE}
            centered
            open={props.open}
            onCancel={props.onCancel}
            width={1000}
            okText={props.okText}
            cancelText={props.cancelText}
            footer={<></>}
            closable={false}
            zIndex={1200}
            getContainer={false}
            destroyOnClose={true}
        >
            <QuotationItemForm
                onFinish={onFinish}
                onCancel={function (): void {
                    props.onCancel && props.onCancel()
                }}
                initialValues={props.initialValues}
            />
        </Modal>
    )
}
